export default {
    title: 'Ayuda A Cada Alumno Hacer Realidad Sus Sueños',
    safeItems: [
        'Libre De Transporte',
        'Oficina Abierta',
        'Ambiente De Trabajo Agradable'
    ],
    bottomTitle: 'Convocatoria Reciente',
}